const ua = navigator.userAgent.toLowerCase();
export const isWx = () => ua.indexOf('micromessenger') !== -1;
export const isMini = () => {
    return window.__wxjs_environment === 'miniprogram' || ua.indexOf('miniprogram') !== -1;
};
export const isIOS = () => {
    if (typeof navigator !== 'undefined') {
        return /(iPhone|iPad|iPod|iOS)/i.test(ua);
    }
};
export const isAndroid = () => {
    if (typeof navigator !== 'undefined') {
        return /(Android)/i.test(ua);
    }
};
export const isIphoneX = () => {
    const term = window.screen.height === 896 && window.screen.width === 414;
    const termOther = window.screen.height === 812 && window.screen.width === 375;
    return isIOS() && (term || termOther);
};
export const isPc = () => {
    if (typeof navigator !== 'undefined') {
        return /(windows|macintosh)/i.test(ua) && !/(mobile)/i.test(ua);
    }
};
export const isWxDevTool = () => {
    return ua.indexOf('wechatdevtools') !== -1;
};
export default {
    isWx,
    isMini,
    isIOS,
    isAndroid,
    isIphoneX,
    isPc,
    isWxDevTool
};
